import './asset-search-details.scss';
import Selectr from 'Selectr';
import { AjaxLoader } from '../../js/ajax-loader';
import { createElementFromHTML, loadYoutubeApi, serializeForm, smoothScrollTo } from '../../js/helper';

class AssetSearchDetails {
    constructor (element) {
        this.$assetSearchDetails = element;
        this.$form = this.$assetSearchDetails.querySelector('form');
        this.$target = this.$assetSearchDetails.querySelector('[data-as-details="results"]');
        this.$$selects = this.$assetSearchDetails.querySelectorAll('[data-select]');
        this.selectbox = [];
        this.$tagList = this.$assetSearchDetails.querySelector('[data-bp-filter="taglist"]');
        this.$counter = this.$assetSearchDetails.querySelector('[data-as-details="counter"]');
        this.$resetButton = this.$assetSearchDetails.querySelector('[data-bp-filter="reset"]');
        this.$categorySidebar = this.$form.querySelector('[data-as-details="sidebar"]');
        this.$$categoryFilter = this.$categorySidebar.querySelectorAll('[data-as-details-sidebar-filter="category"]');
        this.$filterClose = this.$form.querySelector('[data-bp-filter="filter-close"]');
        this.$$filterCheckbox = this.$assetSearchDetails.querySelectorAll('[data-bp-filter="filter-checkbox"]');
        this.$filterBar = this.$form.querySelector('[data-bp-filter="filterbar"]');
        this.$searchInput = this.$assetSearchDetails.querySelector('[data-asset-search="query"]');
        this.searchQueryUrl = this.$searchInput?.getAttribute('data-asset-search-query-url');
        this.$searchSubmit = this.$assetSearchDetails?.querySelector('[data-asset-search="query-submit"]');
        this.$downloadUrl = this.$assetSearchDetails.querySelector('[data-as-details="download-url"]');
        this.$basketUrl = this.$assetSearchDetails.querySelector('[data-as-details="basket-url"]');
        this.$$videos = null;
        this.$addToBasketInput = document.querySelector('[data-assets-search-add-to-basket]');
        this.localStorage = [];
        this.$scrollTarget = this.$assetSearchDetails.querySelector('[data-as-details="scrolltarget"]');
        this.$mobileFilterCount = this.$assetSearchDetails.querySelector('[data-bp-filter-mobile-count]');
        this.$toBasketInput = document.querySelector('#sub-nav_toggle-basket');

        this.searchRequest = null;
        this.$pagination = this.$assetSearchDetails.querySelector('[data-as-details="pagination"]');
        this.$paginationNextPageButton = this.$pagination.querySelector('[data-as-details-next-url]');
        this.resetActive = false;
        this.allowSubmit = true;
        this.lastActiveSelect = null;

        this.timerCount = 1000;
        this.timer = null;
    }

    initialize () {
        this.handleSelect(this.$$selects);
        this.setEvents();
        this.checkSelects();
        this.setResetButton(this.resetActive);
        this.setVideos();
        this.storage().get();
    }

    // set general events
    setEvents () {
        this.$resetButton.addEventListener('click', () => {
            this.setResetButton(false);
            this.resetFilter();
        });

        this.$categorySidebar.addEventListener('change', (e) => {
            if (e.target.getAttribute('data-as-details-sidebar-filter') === 'category') {
                this.resetFilter();
                this.waitAndSubmit();

                if (window.innerWidth >= 1024) {
                    smoothScrollTo(0, this.$scrollTarget.offsetTop, 500);
                }
            }
        });

        this.$filterClose.addEventListener('click', () => {
            const $activeFilterCheckbox = this.$assetSearchDetails.querySelector('[data-bp-filter="filter-checkbox"]:checked');

            if ($activeFilterCheckbox) {
                $activeFilterCheckbox.checked = false;
            }
        });

        this.$$filterCheckbox.forEach((filterCheckbox) => {
            filterCheckbox.addEventListener('change', () => {
                if (filterCheckbox.checked) {
                    const $activeCheckbox = this.$assetSearchDetails.querySelector('[data-as-details="filter-checkbox"]:checked:not([id="' + filterCheckbox.getAttribute('id') + '"])');
                    if ($activeCheckbox) {
                        $activeCheckbox.checked = false;
                    }
                }
            });
        });

        this.$paginationNextPageButton.addEventListener('click', () => {
            this.loadNext();
        });

        this.$assetSearchDetails.addEventListener('click', (e) => {
            if (e.target.getAttribute('data-asset-search-basket')) {
                if (e.target.getAttribute('data-asset-search-basket') === 'add') {
                    e.preventDefault();
                    this.sendToBasket(e.target.href);
                }
            }
        });
    }

    loadNext () {
        if (this.allowSubmit) {
            this.allowSubmit = false;
            this.$target.classList.add('is--loading');

            this.result = new AjaxLoader(this.$paginationNextPageButton.getAttribute('data-as-details-next-url'), {
                requestMethod: 'post',
                requestData: new FormData(this.$form),
                onSuccess: (resultText) => {
                    const results = JSON.parse(resultText);

                    this.setResults(results.results.html, true, results.results.total_count);
                    this.$pagination.firstElementChild.innerHTML = results.pagination.copy;
                    if (results.pagination.next_url) {
                        this.$paginationNextPageButton.setAttribute('data-as-details-next-url', results.pagination.next_url);
                    } else {
                        this.$pagination.classList.add('is--hidden');
                    }
                    this.$target.classList.remove('is--loading');
                    this.allowSubmit = true;
                },
                onError: (error) => {
                    console.warn(error);
                }
            });
        }
    }

    // reset all selectFilter and submit
    resetFilter () {
        this.allowSubmit = false;
        for (let index = 0; index < this.selectbox.length; index++) {
            this.selectbox[index].options.forEach((option) => {
                if (this.selectbox[index].originalType === 'select-one') {
                    if (option.getAttribute('data-default-selected') !== null && option.selected !== true) {
                        this.selectbox[index].setValue(option.value);
                    }
                } else {
                    if (option.selected === true) {
                        this.selectbox[index].setValue(option.value);
                    }
                }
            });
        }
        this.allowSubmit = true;
        this.lastActiveSelect = null;

        this.waitAndSubmit();
    }

    waitAndSubmit () {
        clearTimeout(this.timer);
        this.timer = setTimeout(() => {
            this.filterSubmit();
        }, this.timerCount);
    }

    // set resetbutton active or deactive
    setResetButton (reset) {
        if (reset === true) {
            this.$resetButton.classList.add('is--active');
            this.resetActive = true;
        } else {
            this.$resetButton.classList.remove('is--active');
            this.resetActive = false;
        }
    }

    // check available selectFilter and set Tags (multi-select) or special Placeholder (single-select)
    checkSelects () {
        for (let index = 0; index < this.selectbox.length; index++) {
            if (this.selectbox[index].originalType === 'select-multiple') {
                this.setTagsFromFilter(this.selectbox[index]);
            } else {
                this.setSortLabel(this.selectbox[index]);
            }
        }
    }

    // check options per select and set reset and tags
    setTagsFromFilter (select) {
        select.options.forEach((option) => {
            if (option.selected === true) {
                this.resetActive = true;
                this.setFilter(option.innerHTML);
            }
        });
    }

    // set single-select (sorting) icon
    setSortLabel (select) {
        select.options.forEach((option) => {
            if (option.selected === true) {
                const $label = option.closest('.selectr-container').firstElementChild.firstElementChild;
                const icon = option.getAttribute('data-icon');

                if (icon === 'icon-sorting_z-a') {
                    $label.classList.remove('icon-sorting_a-z');
                    this.resetActive = true;
                } else {
                    $label.classList.remove('icon-sorting_z-a');
                }

                $label.classList.add(option.getAttribute('data-icon'));
            }
        });
    }

    // handler for all selectFilter. Use selectr and set events
    handleSelect ($selects) {
        Object.defineProperty(Selectr.prototype, 'mobileDevice', {
            get () { return false; },
            set () {},
            enumerable: true,
            configurable: true
        });

        $selects.forEach(($select, index) => {
            let selectrOptions = {
                defaultSelected: false,
                searchable: false,
                clearable: false,
                multiple: true,
                nativeDropdown: false,
                placeholder: $select.getAttribute('data-placeholder'),
                taggable: false
            };

            if ($select.getAttribute('data-select') === 'single') {
                if ($select.hasAttribute('data-select-references')) {
                    selectrOptions = {
                        defaultSelected: false,
                        searchable: false,
                        clearable: false,
                        taggable: false,
                        nativeDropdown: false,
                        placeholder: $select.getAttribute('data-placeholder'),
                        customClass: 'is--' + $select.getAttribute('name')
                    };
                } else {
                    selectrOptions = {
                        defaultSelected: false,
                        searchable: false,
                        clearable: false,
                        taggable: false,
                        nativeDropdown: false,
                        customClass: 'is--' + $select.getAttribute('name'),
                        renderOption: selectrRenderFunction
                    };
                }
            }

            function selectrRenderFunction (option) {
                let template;

                if (option.value === 'asc') {
                    template = '<span class="icon-sorting_a-z"></span>';
                }
                if (option.value === 'desc') {
                    template = '<span class="icon-sorting_z-a"></span>';
                }

                return template;
            }

            this.selectbox[index] = new Selectr($select, selectrOptions);

            if (selectrOptions.customClass !== 'is--reference-list') {
                if (this.lastActiveSelect !== '') {
                    if (this.lastActiveSelect === $select.getAttribute('name')) {
                        this.selectbox[index].open();
                    }
                }

                this.selectbox[index].on('selectr.close', () => {
                    this.lastActiveSelect = '';
                });
            }

            this.selectbox[index].on('selectr.select', (option) => {
                if (this.selectbox[index].originalType === 'select-multiple') {
                    this.setFilter(option.innerHTML, () => {
                        this.lastActiveSelect = $select.getAttribute('name');
                        this.setResetButton(true);
                        this.waitAndSubmit();
                    });
                } else {
                    if (this.selectbox[index].config.customClass !== 'is--reference-list') {
                        this.setResetButton(true);
                        this.setSortLabel(this.selectbox[index]);
                        this.waitAndSubmit();
                    } else {
                        if (this.selectbox[index].selectedValue !== '') {
                            const anchor = document.createElement('a');
                            anchor.href = this.selectbox[index].selectedValue;
                            anchor.click();
                        }
                    }
                }
            });

            this.selectbox[index].on('selectr.deselect', (option) => {
                if (this.selectbox[index].originalType !== 'select-one') {
                    this.removeFilter(option.innerHTML, () => {
                        this.lastActiveSelect = $select.getAttribute('name');
                        this.waitAndSubmit();
                    });
                }
            });

            if ($select.getAttribute('data-select') === 'single' && !$select.hasAttribute('data-select-link')) {
                this.setSortLabel(this.selectbox[index]);
            }
        });
    }

    checkForZoom ($element) {
        const $$imageZooms = $element.querySelectorAll('[data-imagezoom="root"]');

        if ($$imageZooms.length > 0) {
            import('../../components/image/image-zoom').then(({ ImageZoom }) => {
                for (let i = 0; i < $$imageZooms.length; i++) {
                    const $imageZoom = $$imageZooms[i];
                    const imageZoomAPI = new ImageZoom($imageZoom, {
                        loader: window.OPTIONS.loader
                    });

                    $imageZoom.API = imageZoomAPI;
                }
            });
        }
    }

    // get result HTML and put it into Target
    setResults (html, append = false, count) {
        if (count > 0) {
            const $results = createElementFromHTML(html);

            if (!append) {
                this.$target.innerHTML = '';
            }

            if ($results.length > 1) {
                $results.forEach((element) => {
                    this.$target.appendChild(element);
                    this.checkForZoom(element);
                });
            } else {
                this.$target.appendChild($results);
                this.checkForZoom($results);
            }
        } else {
            this.$target.innerHTML = '';
        }
    }

    // get sidebar HTML and put it into sidebar
    setSidebar (html) {
        if (html !== null) {
            const $sidebarFilter = createElementFromHTML(html);
            this.$categorySidebar.firstElementChild.innerHTML = '';
            this.$categorySidebar.firstElementChild.appendChild($sidebarFilter);
        } else {
            this.$categorySidebar.firstElementChild.innerHTML = '';
        }
    }

    setVideos () {
        this.$$videos = this.$target.querySelectorAll('[data-asset-search="video"]');

        const loadVideos = (videos) => {
            import('../../js/youtube-player').then(({ YoutubePlayer }) => {
                for (let i = 0; i < videos.length; i++) {
                    const VideoPlayer = new YoutubePlayer(videos[i]); // eslint-disable-line
                }
            });
        };

        if (this.$$videos.length > 0) {
            if (!window.youtubeApi) {
                loadYoutubeApi();

                window.onYouTubeIframeAPIReady = () => {
                    window.youtubeApi = true;
                    loadVideos(this.$$videos);
                };
            } else {
                loadVideos(this.$$videos);
            }
        }
    }

    // get new Filters from HTML and set it as new filters
    setSelectFilter (html) {
        if (html !== null) {
            const $selectFilter = createElementFromHTML(html);
            this.$filterBar.innerHTML = '';

            if ($selectFilter.length > 1) {
                $selectFilter.forEach((element) => {
                    this.$filterBar.appendChild(element);
                });
            } else {
                this.$filterBar.appendChild($selectFilter);
            }

            const waitForPlacement = setInterval(() => {
                clearInterval(waitForPlacement);
                this.$$selects = this.$assetSearchDetails.querySelectorAll('[data-select]');
                this.selectbox = [];
                this.handleSelect(this.$$selects);
            }, 10);
        } else {
            this.$filterBar.innerHTML = '';
        }
    }

    // set document history and replace actual url with new get parameters
    setHistory () {
        history.pushState(null, null, window.location.href.split('?')[0] + '?' + serializeForm(this.$form));
    }

    // remove filter tag if option was deselected inside select
    removeFilter (value, callback) {
        const $$tags = this.$tagList.querySelectorAll('li');

        $$tags.forEach(($tag) => {
            if ($tag.innerText === value.toUpperCase()) {
                $tag.remove();
            }
        });

        if (typeof callback === 'function') {
            callback();
        }
    }

    // set filter tag if option is selected inside select
    setFilter (value, callback) {
        const $tag = document.createElement('li');
        $tag.classList.add('bp-filter__tag');
        const $tagClose = document.createElement('span');
        $tagClose.setAttribute('data-bp-filter', 'tagclose');

        $tag.innerHTML = value;
        $tag.appendChild($tagClose);
        this.$tagList.appendChild($tag);

        $tagClose.addEventListener('click', () => {
            this.removeFilterByTag(value, () => {
                $tag.remove();
                this.waitAndSubmit();
            });
        });

        if (typeof callback === 'function') {
            callback();
        }
    }

    // remove selected option from select if tag was removed
    removeFilterByTag (value, callback) {
        for (let index = 0; index < this.selectbox.length; index++) {
            const foundValue = this.selectbox[index].search(value);
            const arr = [];
            let found = false;

            if (foundValue.length > 0) {
                const selected = this.selectbox[index].getValue(true);

                selected.values.forEach((item, itemIndex) => {
                    if (item.text === value) {
                        arr.push(item.value);
                        found = true;
                    }
                });

                if (found) {
                    this.selectbox[index].setValue(arr);
                }
            }
        }

        if (typeof callback === 'function') {
            callback();
        }
    }

    // handle the ajax request if filter has changed
    filterSubmit () {
        if (this.allowSubmit) {
            this.allowSubmit = false;

            this.$target.classList.add('is--loading');

            this.result = new AjaxLoader(this.$form.getAttribute('action') + '?' + serializeForm(this.$form), {
                requestMethod: this.$form.getAttribute('method'),
                requestData: new FormData(this.$form),
                onSuccess: (resultText) => {
                    const results = JSON.parse(resultText);
                    this.setResults(results.results.html, false, results.results.total_count);
                    this.$counter.innerHTML = results.results.total_count;
                    this.$mobileFilterCount.firstElementChild.innerHTML = results.results.total_count;
                    this.setSidebar(results.sidebar.html);
                    this.setSelectFilter(results.listing_filter.html);
                    this.setVideos();

                    this.setHistory();

                    this.$downloadUrl.href = results.results.download_url;
                    this.$basketUrl.href = results.results.add_to_basket_url;

                    if (results.results.disable_info_actions) {
                        this.$downloadUrl.classList.add('is--disabled');
                        this.$basketUrl.classList.add('is--disabled');
                    } else {
                        this.$downloadUrl.classList.remove('is--disabled');
                        this.$basketUrl.classList.remove('is--disabled');
                    }

                    if (results.pagination.next_url !== null) {
                        this.$pagination.firstElementChild.innerHTML = results.pagination.copy;
                    }

                    if (results.pagination.next_url !== null) {
                        this.$paginationNextPageButton.setAttribute('data-as-details-next-url', results.pagination.next_url);
                        this.$pagination.classList.remove('is--hidden');
                    } else {
                        this.$pagination.classList.add('is--hidden');
                    }

                    this.$target.classList.remove('is--loading');
                    this.allowSubmit = true;
                },
                onError: (error) => {
                    console.warn(error);
                }
            });
        }
    }

    sendToBasket (url) {
        const formData = new FormData();
        const localBasket = localStorage.getItem('basket');

        if (localBasket) {
            const localBasketObject = JSON.parse(localStorage.getItem('basket'));

            if (localBasketObject.length > 0) {
                formData.append('public_items', localBasket.toString());
            }
        }

        new AjaxLoader(url, { // eslint-disable-line
            requestMethod: 'POST',
            requestData: formData,
            onSuccess: (resultText) => {
                const results = JSON.parse(resultText);
                if (results.success) {
                    this.$addToBasketInput.checked = true;
                    this.$toBasketInput.removeAttribute('data-basket-empty');
                    this.$toBasketInput.setAttribute('data-basket-not-empty', '');

                    if (results.public_items !== null) {
                        this.storage().check(results.public_items);
                    }

                    setTimeout(() => {
                        if (this.$addToBasketInput.checked === true) {
                            this.$addToBasketInput.checked = false;
                        }
                    }, 7000);
                } else {
                    console.log(results.message);
                }
            }
        });
    }

    storage () {
        const get = () => {
            this.localBasket = JSON.parse(localStorage.getItem('basket'));
            if (!this.localBasket) {
                this.storage().set();
            }
        };

        const set = (item) => {
            if (item) {
                const $items = JSON.parse(localStorage.getItem('basket')) || [];

                $items.push(item);
                localStorage.setItem('basket', JSON.stringify($items));
            } else {
                localStorage.removeItem('basket');
            }
        };

        const check = (newItems) => {
            this.storage().get();

            const $items = this.localBasket;
            if (this.localBasket !== null) {
                let found = false;

                for (const newItem of newItems) {
                    for (const item of $items) {
                        if (item.id === newItem.id && item.type === newItem.type) {
                            found = true;
                            break;
                        }
                    }

                    if (!found) {
                        this.storage().set(newItem);
                    } else {
                        found = false;
                    }
                }
            } else {
                for (const newItem of newItems) {
                    this.storage().set(newItem);
                }
            }
        };

        return {
            get,
            set,
            check
        };
    }
}

export { AssetSearchDetails };

window.addEventListener('content.loaded', (e) => {
    const eventDetails = e.detail;
    const $context = eventDetails.$context;

    if ($context) {
        const $assetSearchDetails = $context.querySelector('[data-as-details="root"]');

        if ($assetSearchDetails) {
            const $assets = new AssetSearchDetails($assetSearchDetails);
            $assets.initialize();
        }
    }
});
